import { FC } from 'react';

import { useFormContext } from 'react-hook-form';

import RhfRadioGroup from 'components/RadioGroup/RhfRadioGroup/RhfRadioGroup';
import { RHFTextArea } from 'components/RHFTextArea/RHFTextArea';
import { CANINE } from 'constants/prescriptionConstants';
import {
  SAGITTAL_IMPROVE_OPTIONS_CANINE,
  SAGITTAL_IMPROVE_OPTIONS_MOLAR,
  SAGITTAL_IMPROVE_VALUES
} from 'constants/prescriptionOptions';
import { translate } from 'utils';

import SagittalImproveSubOptions from './SagittalImproveSubOptions';

interface Props {
  fieldName: string;
  sideTitle: string;
  improvementType: string;
  isDisabled?: boolean;
}
const SagittalImprove: FC<Props> = ({
  fieldName,
  sideTitle,
  improvementType,
  isDisabled
}) => {
  const improveFieldName = `${fieldName}.${improvementType}`;
  const { watch } = useFormContext();
  const watchSagittalImprove = watch(improveFieldName);
  const getSubTitle = () => {
    if (watchSagittalImprove === SAGITTAL_IMPROVE_VALUES.IMPROVE_ONLY)
      return translate(
        'sagittal_relationship.treatment_option_for_improve_only'
      );
    else if (
      watchSagittalImprove ===
      SAGITTAL_IMPROVE_VALUES.TREATMENT_OPTION_FOR_CANINE
    )
      return translate(
        'sagittal_relationship.treatment_option_for_correction_to_class_i_canine'
      );
    else if (
      watchSagittalImprove ===
      SAGITTAL_IMPROVE_VALUES.TREATMENT_OPTION_FOR_MOLAR
    )
      return translate(
        'sagittal_relationship.treatment_option_for_correction_to_class_i_molar'
      );
  };
  const getImproveOptions = () => {
    if (improvementType === CANINE) return SAGITTAL_IMPROVE_OPTIONS_CANINE;
    else return SAGITTAL_IMPROVE_OPTIONS_MOLAR;
  };
  return (
    <div className='flex flex-col'>
      <div className='flex flex-row space-x-4 p-4 rounded-2xl bg-CHINESE_WHITE items-center'>
        <p className='font-bold text-14px'>{translate(sideTitle)}</p>
        <RhfRadioGroup
          inputProps={{ disabled: isDisabled }}
          options={getImproveOptions()}
          name={improveFieldName}
          className=' flex flex-row space-x-16'
          radioClassName='border-RADIO_BORDER'
          radioItemFont='md:text-17px text-sm'
        />
      </div>
      <div>
        {!!watchSagittalImprove && (
          <div className='flex flex-col px-4'>
            <RHFTextArea
              name={`${fieldName}.text`}
              autogrow
              inputProps={{
                disabled: isDisabled,
                placeholder: translate('settings.please_type_here')
              }}
              maxgrowHeight={260}
            />
            <p className='ml-4 text-14px mt-4'>{getSubTitle()}</p>
            <SagittalImproveSubOptions
              improvementType={improvementType}
              isDisabled={isDisabled}
              fieldName={`${fieldName}.improveSubOptions`}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default SagittalImprove;
